import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import Drug from './components/DrugItem';
import Quantity from './components/QuantityItem';
import Scale from './components/ScaleItem';
import Footer from './components/FooterItem';
import Backdrop from '~/components/BackdropComponent';
import CircularProgress from '@material-ui/core/CircularProgress';
import { showInfusion } from '~/services/infusions';
import { errorMessage } from '~/utils/Message';

import { Container, Text } from './styles';

function InfusionShow({ item }) {
  const [infusion, setInfusion] = useState(item);
  const [loading, setLoading] = useState(false);

  const { used, quantity, attempts, emergency_dose, date } = infusion;

  const loadData = useCallback(async () => {
    setLoading(true);

    try {
      const { data } = await showInfusion(item.id);

      setInfusion(data);
    } catch (error) {
      errorMessage(error);
    } finally {
      setLoading(false);
    }
  }, [item.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <Container>
      <Drug item={infusion} />
      <Quantity used={used} quantity={quantity} />

      <Text>Tentativas de infusão</Text>
      <Scale attempts={attempts} />

      <Footer emergency_dose={emergency_dose} date={date} />

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

InfusionShow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default InfusionShow;
